import axios from "axios";
import { runInAction } from "mobx";
import ApiData from "./ApiData";
import config from "../config.json";
import Msg from "./Msg";
import { restoreSessionToken } from "../utils/auth.utils";

export const req = axios.create({
  baseURL: config.url_api,
  timeout: 600000,
});

/** Путь относительно хоста для эндпоинтов API v3 (baseURL клиента — v1). */
export function apiV3Path(relativePath) {
  const baseV3 = config.url_api.replace(/\/api\/v1\/?$/i, "/api/v3/");
  const path = String(relativePath).replace(/^\//, "");
  return `${baseV3}${path}`;
}

req.interceptors.request.use((config) => {
  const token = localStorage.getItem("at");
  const key = localStorage.getItem("k");

  if (!token || !key) {
    return config;
  }

  try {
    config.headers.Authorization = `Bearer ${restoreSessionToken(token, key)}`;
  } catch {
    localStorage.removeItem("at");
    localStorage.removeItem("k");
  }

  return config;
});

req.interceptors.response.use(
  (config) => {
    return config;
  },
  (e) => {
    if (!axios.isAxiosError(e)) {
      return Promise.reject(e);
    }

    if (e.code === "ERR_CANCELED" || e.name === "CanceledError") {
      return Promise.reject(e);
    }

    const status = e.response?.status;
    if (e.code === "ERR_NETWORK") {
      Msg.writeMessages(`Ошибка: ${e.message} Попробуйте позже.`);
    } else if (status === 401 || localStorage.getItem("User") === null) {
      ApiData.logout();
      Msg.writeMessages(
        "Устаревший токен, пожалуйста, авторизуйтесь повторно.",
      );
    } else if (status === 403) {
      if (!e.config?.suppressNoRight) {
        runInAction(() => {
          ApiData.noRight = true;
        });
      }
      Msg.writeMessages(
        "Недостаточно прав для просмотра, обратитесь к администратору личного кабинета для уточнения",
      );
    } else {
      console.log("!!!!", e.response?.data);
      const message =
        e.response?.data?.message ||
        e.response?.data?.detail?.[0]?.message ||
        e.response?.data?.detail ||
        "Не удалось выполнить запрос.";
      Msg.writeMessages(message);
      console.error(message);
    }

    return Promise.reject(e);
  },
);
